<!-- 节律配置弹窗 -->
<template>
  <div class="two_rhythm">
    <div class="blue_border">
      {{ $t('ifttt.hclConfig') }}
    </div>
    <div class="step rhythm_step rhythm_step2">
      <el-steps
        :space="1000"
        :active="active_step"
        align-center
        finish-status="success"
      >
        <el-step
          :title="'1.'+$t('ifttt.rhythm01')"
          @click.native="stepchange(1);"
        />
        <el-step
          :title="'2.'+$t('ifttt.hcl02')"
          @click.native="stepchange(2)"
        />
      </el-steps>
    </div>

    <div v-show="active_step == 1">
      <div class="dialogGroup_cont">
        <v-choose
          ref="deviceSelect"
          :is_group="true"
          :is-device-force-radio="false"
          :areaid="areaid"
          :area-tree-type="1"
          :execute-type="2"
          :is-compare="true"
          :displaynoarea="true"
          :checkeddata="rhythmModel && rhythmModel['DeviceList']"
          :post-fun-param="getPostFunParam()"
          :confirm-name="$t('ifttt.nextStep')"
          :is-show-check="true"
          :is-group-save-bar="false"
          :is-group-control-bar="true"
          :group-control-title-name="$t('ifttt.hclConfig')"
          :group-control-name="$t('ifttt.areacontrol')"
          :is-confirmc-calibrate="false"
          :is-hcl="true"
          :is-occupied="true"
          :is-occupied-limit-group="true"
          :cur-rule-id="rhythmModel != null?rhythmModel['HCLId']:null"
          :is-cur-rule-group="(rhythmModel != null && rhythmModel['RhythmType']==0)?true:false"
          :post-fun-param-tree="radio1!=null?{gatewayVDeviceId:radio1.VDeviceId}:null"
          @confirm="confirm"
          @groupControlEvent="groupControlEvent"
          @changeGroupPost="changeGroupPost"
        />
      </div>
    </div>
    <div
      v-if="active_step == 2"
      class="ehystep2_cont"
    >
      <div class="ehy_cont">
        <div
          class="tab_header clearfix"
          style="position: relative;"
        >
          <div class="tab-top">
            <div style="width:70%;padding-top:30px;">
              <div
                class="header_tabset set1"
                :class="{ header_current: cur == 0 }"
                @click="clickrhythmline(0)"
              >
                {{ $t('ifttt.hclLine') }}
              </div>
              <div
                class="header_tabset set2"
                :class="{ header_current: cur == 1 }"
                @click="clickrhythmline(1)"
              >
                {{ $t('hcl.set') }}
              </div>

              <div
                class="custom_base"
                style="text-align: center;"
              >
                <span>{{ $t('ifttt.hclName') }}：</span>
                <input
                  v-model="name"
                  :placeholder="$t('ifttt.hclNameTips')"
                  maxlength="32"
                >
              </div>
            </div>
            <div style="width:30%">
              <div class="template-btn-box">
                <div class="template-flex">
                  <div
                    class="template-btn-choose template-flex"
                    @click="showDialogTemplate(0)"
                  >
                    {{ $t('hcl.oppleTemplate') }}
                  </div>
                  <div
                    class="template-btn-choose template-flex"
                    @click="showDialogTemplate(1)"
                  >
                    {{ $t('hcl.template') }}
                  </div>
                </div>
                <div
                  class="template-btn-save template-flex"
                  @click="saveTemplate()"
                >
                  {{ $t('hcl.saveTemplate') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content clearfix">
          <div v-if="cur == 0">
            <div v-if="cur == 0">
              <div class="rhythm-chart">
                <div style="display:flex;">
                  <div style="width:70%;">
                    <div class="chart-top">
                      <el-dropdown @command="handleAdd">
                        <span class="el-dropdown-link">
                          {{ modetypename }}<i class="el-icon-arrow-down el-icon--right" />
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-for="(item,index) in optionsAdd"
                            :key="index"
                            :command="item"
                          >
                            {{ item.label }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-checkbox
                        v-model="isShowLabel"
                        @change="changeIsShowLabel"
                      >
                        {{ $t('hcl.chartAllData') }}
                      </el-checkbox>
                    </div>
                  </div>
                  <div style="width:30%" />
                </div>
                <hcl-Echarts
                  v-if="isShowChart"
                  ref="hclEchart"
                  :time-list="lightTimeListData"
                  :config-list="hclConfig"
                  :is-show-label="isShowLabel"
                  :interval-time="intervalTime"
                  :min-light="minLight"
                  @changeTimeList="changeEchartsData"
                />
              </div>
            </div>
          </div>

          <div v-if="cur == 1">
            <div v-if="curs == 0">
              <div class="user-defined">
                <vuescroll>
                  <div class="user-defined-contianer">
                    <template v-for="(item,index) in lightTimeList">
                      <div
                        v-if="index !== lightTimeList.length-1"
                        :key="index"
                        class="use-defined-item"
                      >
                        <div>
                          <el-time-picker
                            v-model="item.time"
                            :editable="true"
                            :disabled="index === 0"
                            class="dialog_time"
                            format="HH:mm"
                            value-format="HH:mm"
                            :clearable="false"
                            :picker-options="{selectableRange:ableTimeRange(item,index)}"
                          />
                        </div>
                        <template v-if="hclConfig.HCLMode !== onlyCCT">
                          <div class="curr-tip-item min-width">
                            <div class="curr-tip-inlinesub">
                              {{ $t("ifttt.lightName") }}
                            </div>
                            <div class="slider_width">
                              <div class="slider_percent input_slider ">
                                <el-slider
                                  v-model="item.Bright"
                                  :min="minLight"
                                  :max="100"
                                  show-input
                                  @change="ctrltypechange($event,1,item,index)"
                                />
                              </div>
                            </div>
                            &nbsp;%
                          </div>
                        </template>
                        <template v-if="hclConfig.HCLMode !== onlylight">
                          <div class="curr-tip-item min-width">
                            <div class="curr-tip-inlinesub">
                              {{ $t("ifttt.colorName") }}
                            </div>
                            <div class="slider_width">
                              <div class="slider_percent input_slider slider_color cct-color">
                                <el-slider
                                  v-model="item.CCT"
                                  :min="$store.state.colorTemperatureRange.Min"
                                  :max="$store.state.colorTemperatureRange.Max"
                                  show-input
                                  @change="ctrltypechange($event,2,item,index)"
                                />
                              </div>
                            </div>
                            &nbsp;K
                          </div>
                        </template>
                        <div
                          v-if="index !== 0"
                          style="margin-left:auto;"
                        >
                          <i
                            class="icon--1 icon-delete"
                            @click="delLightTime(index)"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </vuescroll>
                <div class="use-defined-item item-border">
                  <div class="use-defined-add">
                    {{ $t('hcl.addTime') }}
                  </div>
                  <div>
                    <el-time-picker
                      v-model="addTimeFormData.time"
                      :editable="true"
                      class="dialog_time  add-time-picker"
                      format="HH:mm"
                      value-format="HH:mm"
                      :clearable="false"
                    />
                  </div>
                  <template v-if="hclConfig.HCLMode !== onlyCCT">
                    <div class="curr-tip-item min-width">
                      <div class="curr-tip-inlinesub">
                        {{ $t("ifttt.lightName") }}
                      </div>
                      <div class="slider_width">
                        <div class="slider_percent input_slider ">
                          <el-slider
                            v-model="addTimeFormData.Bright"
                            :min="minLight"
                            :max="100"
                            show-input
                          />
                        </div>
                      </div>
                      <span>&nbsp;%</span>
                    </div>
                  </template>
                  <template v-if="hclConfig.HCLMode !== onlylight">
                    <div class="curr-tip-item min-width">
                      <div class="curr-tip-inlinesub">
                        {{ $t("ifttt.colorName") }}
                      </div>
                      <div class="slider_width">
                        <div class="slider_percent input_slider slider_color cct-color">
                          <el-slider
                            v-model="addTimeFormData.CCT"
                            :min="$store.state.colorTemperatureRange.Min"
                            :max="$store.state.colorTemperatureRange.Max"
                            show-input
                          />
                        </div>
                      </div>
                      <span>&nbsp;K</span>
                    </div>
                  </template>
                  <div style="margin-left:auto;">
                    <el-button
                      type="primary"
                      class="add-btn"
                      @click="handleAddTime"
                    >
                      {{ $t('hcl.add') }}
                    </el-button>
                  </div>
                </div>
                <div class="add-tips">
                  <i class="el-icon-star-on" />{{ $t('hcl.warning6') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="button_box clearfix"
      >
        <el-button
          class="fleft"
          @click="upstep2"
        >
          {{ $t('ifttt.upStep') }}
        </el-button>
        <el-button
          :loading="btnloading"
          class="fright save_blue"
          @click="save"
        >
          {{ $t('ifttt.save') }}
        </el-button>
      </div>
    </div>

    <div
      v-if="dialogTemplate && active_step == 2"
      class="template-bg"
    />
    <div
      v-show="dialogTemplate && active_step == 2"
      class="template-box"
    >
      <i
        class="el-icon-close"
        @click="dialogTemplate = false"
      />
      <div
        v-if="dialogTemplateIndex === 0"
        class="template-content"
      >
        <div class="template-top">
          <template v-for="(item,index) in templateData">
            <div
              :key="index"
              :class="[oppleTemplateIndex === index?' mini-act template-mini':'template-mini']"
              @click="handleChangeHclTemplate(index)"
            >
              <div
                class="template-mini-icon"
                :style="{backgroundImage: 'url('+ item.IconUrl +')'}"
              />
              {{ item.TemplateName }}
            </div>
          </template>
        </div>
        <div>
          <el-carousel
            ref="hcltemplate"
            arrow="always"
            height="500px"
            :autoplay="false"
            indicator-position="none"
            @change="changeHclTemplate"
          >
            <el-carousel-item
              v-for="item in templateData"
              :key="item.TemplateId"
            >
              <div
                class="template-item"
                :style="{backgroundImage: 'url('+ item.BgUrl +')'}"
              >
                <div class="template-text">
                  <div
                    class="template-img-big"
                    :style="{backgroundImage: 'url('+ item.IconUrl +')'}"
                  />

                  <div class="template-des">
                    <div
                      :class="$store.state.lang"
                      v-html="item.TemplateSummary"
                    />
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div
        v-else
        class="template-content template-custom"
      >
        <template v-if="dialogTemplate">
          <div class="template-top template-flex">
            <div
              class="search_way"
              style="width: 243px;margin: 0px 20px 0px 5px;"
            >
              <el-input
                v-model="searchTemplate"
                :placeholder="$t('hcl.search')"
                size="medium"
                @keyup.enter.native="searchTemplatelist"
              />
              <el-button
                class="search_button text-button"
                icon="el-icon-search "
                type="text"
                @click="searchTemplatelist"
              />
            </div>

            <div v-if="!templateEdite">
              <el-button
                type="text"
                @click="templateEdite = true"
              >
                {{ $t('hcl.modify') }}
              </el-button>
            </div>
            <div v-else>
              <el-button
                class="color"
                type="text"
                @click="handleSelectAll()"
              >
                {{ templateALLCancle?$t('hcl.clear'):$t('hcl.all') }}
              </el-button>

              <el-button
                class="color"
                type="text"
                @click="templateEdite=false,templateALLCancle=false,handleCancle()"
              >
                {{ $t('hcl.cancle') }}
              </el-button>

              <el-badge
                :value="deleteDataLength"
                :hidden="deleteDataLength ===0"
              >
                <el-button
                  class="delete color"
                  @click="handleDeleteUserTemplate()"
                >
                  <i class="el-icon-delete" />{{ $t('hcl.del') }}
                </el-button>
              </el-badge>
            </div>
          </div>
          <div class="card-box">
            <vuescroll>
              <div class="card-list">
                <div :class="[userTemplateData.length>0?'':' card_content_backimage']" />
                <template v-for="(item,index) in userTemplateData">
                  <div
                    :key="item.TemplateId"
                    class="card-item"
                    @click="handleChooseUserTemplate(item)"
                  >
                    <div class="card-top">
                      <el-checkbox
                        v-if="templateEdite"
                        v-model="item.isChecked"
                        class="card-checkbox"
                        @change="handleChooseUserTemplate(item)"
                      />
                      <div
                        v-if="item.isEditor"
                        class="card-title"
                      >
                        <el-input
                          ref="editorTemplate"
                          v-model="item.TemplateName"
                          class="card-input"
                          :maxlength="maxLength"
                          @keyup.enter.native="saveUserTemplate(item)"
                          @blur="saveUserTemplate(item)"
                        />
                      </div>
                      <div
                        v-else
                        class="card-title"
                        @click.stop="editorUserTemplate(item,index)"
                      >
                        {{ item.TemplateName }}<i class="el-icon-edit" />
                      </div>
                    </div>
                    <div class="card-content">
                      <ul class="card-ul">
                        <!-- <li class="card-li" v-if="item.isEditor">{{$t('hcl.introduce')}}：<el-input class="card-input" ref="editorTemplate" :maxlength="maxLength" @keyup.enter.native="saveUserTemplate(item)" v-model="item.TemplateSummary"></el-input>
                        </li>
                        <li class="card-li" v-else>{{$t('hcl.introduce')}}：<span class="font-color">{{item.TemplateSummary}} <i @click.stop="editorUserTemplate(item,index)" class="el-icon-edit"></i></span> </li> -->
                        <!-- <li class="card-li">{{$t('hcl.type')}}：<span class="font-color">{{item.HCLDimmingMode==0?$t('hcl.gradient'):$t('hcl.jump')}} ; {{modeType(item)}}</span></li> -->
                        <li class="card-li">
                          {{ $t('hcl.type') }}：<span class="font-color">{{ modeType(item) }}</span>
                        </li>
                        <li class="card-li">
                          {{ $t('hcl.time') }}：<span class="font-color">{{ timeOffset(item.CreateTime).split('T')[0] }} {{ timeOffset(item.CreateTime).split('T')[1] }}</span>
                        </li>
                      </ul>

                      <div class="card-bottom">
                        <div
                          class="card-choose"
                          @click="handleChoose(item)"
                        >
                          {{ $t('hcl.useTemplate') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </vuescroll>
          </div>
        </template>
      </div>

      <div
        v-if="dialogTemplateIndex === 0"
        class="template-footer"
      >
        <div
          class="template-btn"
          @click="chooseTemplateInChart"
        >
          {{ $t('hcl.useTemplate') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import vGatewaycard from '@/components/common/cardtwoSmall.vue';
import vCard from '@/components/common/card.vue';
import vChoose from '@/components/common/deviceChoose.vue';
import hclEcharts from '@/components/common/hcl/hclEcharts'
import { CreateHCL, FindHCL, EditHCL, FindSysHCLTemplateList, FindUserHCLTemplateList, CreateHCLTemplate, DeleteHCLTemplate, UpdateHCLTemplate } from '@/axios/IHcl.js';
import { alerterror, alertsuccess, warning,info } from '@/assets/js/common.js';
import moment from 'moment'
import { postWebIOSocket } from '@assets/socket';

export default {
  components: {
    vuescroll,
    vChoose,
    vCard,
    vGatewaycard,
    hclEcharts
  },
  props: {
    gpNo: {
      type: Number,
      default: -1 //区域id
    },
    constantid: {
      type: Number,
      default: -1 //恒照度id
    }
  },
  data() {
    return {
      lightCCT: 3,//亮度+色温
      onlylight: 1,//仅亮度
      onlyCCT: 2,//仅色温
      areaid: -1,
      name: this.$t('ifttt.hcl'),
      loading: false, //是否加载中
      btnloading: false, //保存加载中11111
      refresh: false,//让组件加载
      isrefresh: false, //是否刷新
      optionsAdd: [{
        value: 0,
        label: this.$t('ifttt.hourxh')
      }, {
        value: 1,
        label: this.$t('ifttt.secondsxh')
      }], //模式选择 24小时 24秒
      modetypename: this.$t('ifttt.hourxh'), //中文描述
      modetype: 0, //循环模式 0默认模式（24小时循环） 1演示模式（24秒循环）
      lightTimeList: [], //action对象
      lightTime: [], // 灯具配置集合
      windowtime: [], // 窗帘配置集合
      checkDevice: [], //选中的设备集合
      rhythmModel: null, //节律对象
      active_step: 1, //选择的步骤
      is_check: true, //是否复选
      cur: 0, //0 曲线 1 自定义
      curs: 0, // 0 灯具 1 窗帘
      curswiper: -1, //窗帘时间段索引
      radio1: '', //选择的网关
      wifiData: [], //网关列表
      card_list: [], //设备集合
      isGroupPost: false,
      select: false, // 全选按钮
      curRuleId: null, //当前规则ID
      isCurRuleGroup: null, //修改当前规则（是否组控）
      lightTimeListData: [], //传入echarts图片
      lightTimestepList: [],
      base_data: '2022-01-01',
      base_date1: '2022-01-02',
      isShowLabel: false, //显示节点数据
      dialogTemplate: true, //节律模板弹窗
      dialogTemplateIndex: 0,//节律模板弹窗0、模板，1、自定义列表
      oppleTemplateIndex: 0,//欧普模板index
      hclConfig: {
        HCLDimmingMode: 0,
        HCLMode: 3
      }, //echart默认参数HCLDimmingMode是节律类型、HCLMode是亮度or色温
      templateData: [], //欧普模板数据
      userTemplateData: [],//欧普模版数据
      userTemplateDateItem: null,
      isShowChart: false, // 熟悉echart数据vif方案
      radio: true,
      searchTemplate: "",//搜索自定义模板
      timePickRange: [],//时间选择插件的选值范围排除
      userTemplateDelData: [],
      templateALLCancle: false,
      addTimeFormData: {
        time: "00:00",
        Bright: this.minLight,
        CCT: 0
      },
      intervalTime:!this.$store.state.isNoLimit? 60 : 1,
      templateEdite: false,
      cloneTempalteName: null,
      minLight: !this.$store.state.isNoLimit ? this.$store.state.staticConfig.AbilityConfig.DefaultValue.HCL['0x03130000'].Value.minValue :  0//
    };
  },
  computed: {
    maxLength: function () {
      return this.$store.state.lang === 'zh-cn' ? 20 : 36
    },
    deleteDataLength: function () {
      this.userTemplateDelData = []
      this.userTemplateData.forEach((item, index) => {
        if (item.isChecked === true) {
          this.userTemplateDelData.push(item.TemplateId)
        }
      })
      return this.userTemplateDelData.length
    },
  },
  destroyed() {
    this.initsocket();
    //this.removehighid();
  },
  created() {
    this.areaid = this.gpNo;
    this.initsocket();
  },
  mounted() {
    this.areaid = this.gpNo;
    this.$nextTick(() => {
      this.dodrawline();
    })
    this.dofindination();
  },
  methods: {
    minIntervalTime() {
      return this.intervalTime * 60 * 1000;
    },
    resetDefaultTime() {
      this.addTimeFormData = {
        time: "00:00",
        Bright: this.minLight,
        CCT: 0
      }
    },
    handleAddTime() {
      if (this.lightTimeList.length >= 12 && !this.$store.state.isNoLimit) {
        return warning(this, this.$t('ifttt.maxConfigMessage'))
      }

      if (this.lightTimeList.length >= 32 && this.$store.state.isNoLimit) {
        return warning(this, this.$t('ifttt.maxConfigMessage30'))
      }
      let index = null
      for (let i = 0; i < this.lightTimeList.length; i++) {
        if (this.lightTimeList[i + 1] != undefined && this.reduceTime(this.lightTimeList[i].time, this.lightTimeList[i + 1].time, this.addTimeFormData.time)) {
          index = i
          break;
        }
      }

      if (index !== null) {
        this.lightTimeList.splice(index + 1, 0, deepCloneNew(this.addTimeFormData))
        this.resetDefaultTime()
      } else {
        warning(this, this.$t('ifttt.warning3'));
      }
    },
    reduceTime(startTime, endTime, addTime) {

      const start = this.gettimeStamp(`${this.base_data} ${startTime}:00`) + this.minIntervalTime()
      const end = this.gettimeStamp(`${this.base_data} ${endTime}:00`) - this.minIntervalTime()
      const add = this.gettimeStamp(`${this.base_data} ${addTime}:00`)

      if (start <= add && add <= end) {
        return true
      } else {
        return false
      }
    },
    ableTimeRange(data, index) {
      if (index === 0) {
        return `${this.lightTimeList[index].time}:00 - 00:00:00`
      } else if (index === this.lightTimeList.length - 1) {
        return `23:50:00 - 23:59:00`
      } if (index === this.lightTimeList.length - 2) {
        const hour = moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index - 1].time}:00`) + this.minIntervalTime()).format('HH')
        const min = Number(moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index - 1].time}:00`) + this.minIntervalTime()).format('mm'))
        return `${hour}:${min}:00 - 23:50:00`
      } else {
        const hour1 = moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index - 1].time}:00`) + this.minIntervalTime()).format('HH')
        const hour = moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index + 1].time}:00`) - this.minIntervalTime()).format('HH')
        const min = Number(moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index + 1].time}:00`) - this.minIntervalTime()).format('mm'))
        const min1 = Number(moment(this.gettimeStamp(`${this.base_data} ${this.lightTimeList[index - 1].time}:00`) + this.minIntervalTime()).format('mm'))
        return `${hour1}:${min1}:00 - ${hour}:${min}:00`
      }
    },
    modeType(item) {
      return item.HCLMode === this.lightCCT ? this.$t("hcl.lightCCT") : item.HCLMode === this.onlylight ? this.$t("hcl.onlyLight") : this.$t("hcl.onlyCCT")
    },
    handleCancle() {
      this.userTemplateData.forEach(item => {
        item.isChecked = false
      })
    },
    handleSelectAll() {
      this.templateALLCancle = !this.templateALLCancle
      const falseIndex = this.userTemplateData.findIndex(item => {
        return item.isChecked === false
      })

      this.userTemplateData.forEach(item => {
        if (falseIndex !== -1) {
          item.isChecked = true
        } else {
          item.isChecked = !item.isChecked
        }
      })
    },
    handleDeleteUserTemplate() {
      DeleteHCLTemplate(this.userTemplateDelData, this.functionDoDelUserTemplate)
    },
    functionDoDelUserTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.searchTemplatelist()
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    handleChooseUserTemplate(item) {
      if (this.templateEdite) {
        item.isChecked = !item.isChecked
      }
    },
    editorUserTemplate(item, index) {
      this.userTemplateData.map(item => {
        return item.isEditor = false
      })

      this.userTemplateDateItem = item
      this.cloneTempalteName = deepCloneNew(item)

      item.isEditor = true
      this.$nextTick(() => {
        this.$refs.editorTemplate[0].focus()
      })
    },
    saveUserTemplate(val) {
      if (!val.TemplateName) {
        warning(this, this.$t('hcl.warning8'))
        return;
      }
      val.isEditor = false
      if (this.cloneTempalteName.TemplateName !== val.TemplateName)
        UpdateHCLTemplate(this.userTemplateDateItem, this.functionDoUpdateHCLTemplate)
    },
    functionDoUpdateHCLTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.searchTemplatelist()
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    searchTemplatelist() {
      const param = {
        platformType: 1,
        templateName: this.searchTemplate
      }
      FindUserHCLTemplateList(param, this.functionDoFindUserHCLTemplateList)
    },
    functionDoFindUserHCLTemplateList(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.userTemplateData = []
        rs.Result.forEach(item => {
          item.isEditor = false
          item.isChecked = false
          this.userTemplateData.push(item)
        })

      }
    },
    handleChoose(val) {
      this.formatTemplateData(val)
      this.dialogTemplate = false
    },
    doDeleteTemplate() {
      const para = {
        templateId: this.chooseData
      }
      DeleteHCLTemplate(para, this.functionDoDeleteHCLTemplate)
    },
    functionDoDeleteHCLTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    showDialogTemplate(val) {
      this.dialogTemplateIndex = val
      this.dialogTemplate = true
      if (val === 1) {
        this.searchTemplatelist()
      }
    },
    saveTemplate() {
      if (this.lightTimeList.length > 0) {
        const para = {
          TemplateName: this.name,
          PlatformType: 1, //商照1,家具0
          HCLMode: this.hclConfig.HCLMode,
          HCLDimmingMode: this.hclConfig.HCLDimmingMode,
          ActionList: []
        }

        this.lightTimeList.forEach(n => {
          var tempmodel = {};
          tempmodel.Hour = Number(n.time.split(':')[0])
          tempmodel.Min = Number(n.time.split(':')[1])
          tempmodel.Brightness = n.Bright
          tempmodel.CCT = n.CCT;
          para.ActionList.push(tempmodel);
        })

        CreateHCLTemplate(para, this.functionDoCreateHCLTemplate)
      }
    },
    functionDoCreateHCLTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    chooseTemplateInChart() {
      this.handleChangeHclTemplate(this.oppleTemplateIndex)
      this.isShowChart = false
      this.formatTemplateData(this.templateData[this.oppleTemplateIndex], 1)
      this.dialogTemplate = false
    },
    formatTemplateData(data, type = 0) {
      const chooseData = deepCloneNew(data)
      if (type === 1) {
        chooseData.ActionList.unshift({
          Brightness: this.minLight,
          CCT: this.$store.state.colorTemperatureRange.Min,
          Hour: 0,
          Min: 0
        })
        chooseData.ActionList.push({
          Brightness: this.minLight,
          CCT: this.$store.state.colorTemperatureRange.Min,
          Hour: 24,
          Min: 0
        })
      }
      this.lightTimeList = []
      chooseData.ActionList.forEach((n, i) => {
        var _model = {};
        var _timearry = "";
        _timearry = (n.Hour >= 10 ? n.Hour : '0' + n.Hour) + ":" + (n.Min >= 10 ? n.Min : '0' + n.Min);
        _model.time = _timearry;
        if (n.Brightness == 255) {
          _model.Bright = 100
        } else {
          _model.Bright = n.Brightness;
        }
        _model.CCT = n.CCT;
        this.lightTimeList.push(_model);

        _model = null;
      })

      this.hclConfig.HCLDimmingMode = chooseData.HCLDimmingMode;
      this.hclConfig.HCLMode = chooseData.HCLMode

      this.dodrawline();
    },
    handleChangeHclTemplate(index) {
      this.$refs.hcltemplate.setActiveItem(index)
    },
    changeHclTemplate(val) {
      this.oppleTemplateIndex = val
    },
    changeIsShowLabel(val) {
      this.$emit('changeIsShowLabel', val)
    },
    stepchange(_step) {
      this.active_step = _step;
      if (this.active_step == 1) {
        this.$forceUpdate();
        setTimeout(param => { this.$refs.deviceSelect.refresh(); }, 100);
        if (this.isGroupPost == true) {
          setTimeout(this.groupControlEvent, 100, this.isGroupPost);
        }
      }
    },
    groupControlEvent(event) {
      this.$refs.deviceSelect.groupEventNone(event);
      if (event == true) { this.$refs.deviceSelect.checkAll(false); }
      if (event) { warning(this, this.$t('ifttt.groupControlTip')); }
      this.$nextTick(()=>{
        this.isGroupPost = event;
        this.$refs.deviceSelect.setGroupControlValue(this.isGroupPost);
      })
    },

    //通过选中卡片的checkbox 或者通过全选，来判断是否是区控
    changeGroupPost(val,show){
      this.isGroupPost=val
      this.$refs.deviceSelect.setGroupControlValue(this.isGroupPost);
      if(show){
        this.$alert(this.$t('hcl.warning7'), '', {
          confirmButtonText: this.$t('user.yes'),
          callback: action => {
          }
        });
      }
    },
    /* 移除socket
    */
    initsocket() {
      postWebIOSocket('sync_info_removeall_event');
      this.$store.dispatch('changeIsregisterSocket', true);
    },
    hasdata(val) {
      var rtvalue = false;
      this.lightTimeList.forEach(n => {
        if (n.DevType == val) {
          rtvalue = true;
        }
      })
      return rtvalue;
    },
    /* 点击画灯具节律曲线
    */
    clickrhythmline(_cur) {
      this.cur = _cur;
      if (_cur == 0) {

        this.dodrawline();
      }
    },
    /* 画柱状图
    * _ss：色温
    * _data 照度值
    */
    drawLine(_ss, _data, _time) {
      const firstDay = this.gettimeStamp(`${this.base_data} 00:00:00`);
      const lastday = this.gettimeStamp(`${this.base_date1} 00:00:00`);

      this.lightTimeListData = [];
      for (let i = 0; i < this.lightTimeList.length; i++) {
        let time = this.lightTimeList[i].time;
        if (time !== "24:00") {
          this.lightTimeListData.push({
            Bright: this.lightTimeList[i].Bright,
            CCT: this.lightTimeList[i].CCT,
            value: [this.gettimeStamp(`${this.base_data} ${time}:00`), this.lightTimeList[i].Bright],

          })
        } else {
          this.lightTimeListData.push({
            Bright: this.lightTimeList[i].Bright,
            CCT: this.lightTimeList[i].CCT,
            value: [lastday, this.lightTimeList[i].Bright],
          })
        }
      }


      if (this.lightTimeList.length === 0) {
        this.lightTimeListData.unshift({
          Bright: this.minLight,
          CCT: this.$store.state.colorTemperatureRange.Min,
          value: [firstDay, this.minLight],
        })

        this.lightTimeListData.push({
          Bright: this.minLight,
          CCT: this.$store.state.colorTemperatureRange.Min,
          value: [lastday, this.minLight],
        })
      }

      this.isShowChart = false
      this.$nextTick(() => {
        this.isShowChart = true
      })

    },
    /* 下拉改变模式
    * item：下拉对象
    */
    handleAdd(item) {
      this.modetypename = item.label;
      this.modetype = item.value;
    },
    /* 去画柱状图
    */
    dodrawline() {

      var ss = []; //色温
      var data = []; //照度
      var time = [];//自定义时间

      this.lightTimeList.forEach(n => {
        ss.push(n.CCT);
        data.push(n.Illuminance);
        time.push(n.time);
      });

      this.drawLine(ss, data, time);
      ss = null;
      data = null;
    },
    confirm(val) {
      this.removeTreeDevice([val]);
      this.createGrop();
      this.drawLine();
    },
    /* 点击选中设备
    * list 点击对象
    */
    removeTreeDevice(list) {
      //选中的设备
      this.card_list = list[0];
      this.getCheckedDataDevice();
    },
    /* 获得选中的设备
    */
    getCheckedDataDevice() {
      var _arry = [];
      this.card_list.forEach(item => {
        if (item.ischecked) {
          _arry.push(item);
        }
      });
      this.checkDevice = _arry;
      _arry = null;

      if (this.checkDevice.length == this.getCardTolal()) {
        this.select = true;
      } else {
        this.select = false;
      }
    },
    getCardTolal() {
      var num = 0
      this.card_list.forEach(item => {
        if (item.hidden != true) {
          num++;
        }
      });
      return num;
    },
    /* 删除灯具的时间段
    */
    delLightTime(index) {
      this.lightTimeList.splice(index, 1);
      alertsuccess(this, this.$store.state.rightStatusCode);
    },
    /* 改变颜色执行的方法
    * ctrltype 类型
    * item 执行对象
    */
    ctrltypechange(event, type, item, index) {
      try {
        let changeTempBrightCCT = (index) => {
          if (type === 1) {
            this.lightTimeList[index].Bright = + Number(event.toFixed(0));
          } else {
            this.lightTimeList[index].CCT = event
          }
        }
        if (index === 0 || index === this.lightTimeList.length - 1) {
          changeTempBrightCCT(0)
          changeTempBrightCCT(this.lightTimeList.length - 1)
        }
      }
      catch (err) { }
    },
    /* 页面初始化查询节律
    */
    dofindination() {
      if (this.constantid != -1 && this.constantid != null) {
        var para = { hclId: this.constantid };
        FindHCL(para, this.functionDoFind);
        para = null;
      } else {
        var _param = this.$store.state.areasGpName[this.areaid];
        _param = _param && _param["GpName"] + '.';
        this.name = _param + this.$t('ifttt.hcl');
        _param = null;
      }
      FindSysHCLTemplateList({ platformType: 1 }, this.functionDoFindSysHCLTemplate)

    },
    functionDoFindSysHCLTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.templateData = rs.Result
      }
    },
    /* 页面初始化查询节律 接口返回加数据处理 对数据赋值
    * rs 接口返回的数据包
    */
    functionDoFind(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.rhythmModel = rs.Result;
          if (this.rhythmModel.HCLName != null) { this.name = this.rhythmModel.HCLName; }
          if (this.rhythmModel && this.rhythmModel.ActionList.length > 0) {
            this.dialogTemplate = false
          }
          if (this.rhythmModel && this.rhythmModel['DeviceList']) { this.checkDevice = this.rhythmModel['DeviceList']; }

          this.modetype = this.rhythmModel.HCLCycleMode;
          this.isGroupPost = this.rhythmModel.HCLControlType == 0;
          this.modetypename = this.optionsAdd[this.modetype].label;

          try {
            this.areaid = this.rhythmModel.GpNo;

          } catch (error) {

          }

          if (this.rhythmModel != null) {
            this.formatTemplateData(this.rhythmModel)
          }

          this.active_step = 2;
        }
      }
    },
    getPostFunParam() {
      var param = {
        _gpNo: this.areaid,
        pageIndex: 1,
        pageSize: this.$store.state.pageTotalLimit,
        childCategoryType: 2
      };
      if (this.rhythmModel != null && this.rhythmModel.HCLId != null) {
        param["hclId"] = this.rhythmModel.HCLId;
      }
      return param;
    },
    /* 选择 好设备 点击确定
    */
    createGrop() {
      if (this.doVerification(false)) {
        if (this.active_step < 3) {
          this.active_step = this.active_step + 1;
        } else {
          this.active_step = 3;
        }
      }

    },
    /* 点击下一步
    */
    upstep2() {
      if (this.active_step > 1) {
        this.active_step = this.active_step - 1;
        if (this.active_step == 1) {
          this.$forceUpdate();
          setTimeout(param => { this.$refs.deviceSelect.refresh(); }, 100);
          if (this.isGroupPost == true) {
            setTimeout(this.groupControlEvent, 100, this.isGroupPost);
          }
        }
      } else {
        this.active_step = 1;
      }
    },
    /* 验证要提交的数据 是否符合
    */
    doVerification(ispost) {

      if (this.checkDevice.length == 0 && this.isGroupPost == false) {
        warning(this, this.$t('ifttt.warning1'));
        return false;
      } else if (ispost) {
          if (this.lightTimeList.length > 2) {
            return true;
          } else {
            warning(this, this.$t('ifttt.warning2'));
            return false;
          }
        } else {
          return true;
        }

    },
    /* 去保存数据
    */
    doSave() {
      if (this.doVerification(true)) {
        this.btnloading = true;
        var postData = {};
        postData.HCLCycleMode = this.modetype
        postData.HCLControlType = this.isGroupPost ? 0 : 1
        postData.HCLMode = this.hclConfig.HCLMode
        postData.DeviceList = [];
        postData.ActionList = [];
        postData.HCLName = this.name;
        postData.HCLDimmingMode = this.hclConfig.HCLDimmingMode
        postData.IsEnable = true

        if (postData.HCLControlType === 1) {
          this.checkDevice.forEach(n => {
            postData.DeviceList.push({
              VDeviceId: n.VDeviceId,
              DeviceName: n.DeviceName,
              ChannelId: n.ChildId != null ? n.ChildId : n.ChannelId,
            });
          })
        }

        postData.GpNo = this.areaid;

        if (this.lightTimeList.length > 0) {
          this.lightTimeList.forEach(n => {
            var tempmodel = {};
            tempmodel.Hour = Number(n.time.split(':')[0])
            tempmodel.Min = Number(n.time.split(':')[1])
            tempmodel.Brightness = n.Bright
            tempmodel.CCT = n.CCT;
            postData.ActionList.push(tempmodel);
          })
        }


        if (this.rhythmModel != null && this.rhythmModel.HCLId != null) {
          //修改
          postData.HCLName = this.name;
          postData.HCLId = this.rhythmModel.HCLId;
          postData.IsEnable = this.rhythmModel.IsEnable
          EditHCL(postData, this.functionDoNotice);
        } else {
          //新增
          CreateHCL(postData, this.functionDoNotice);

        }
      }

    },

    /* 去保存数据 接口返回数据处理
    * rs 接口返回数据包
    */
    functionDoNotice(rs, para) {
      this.btnloading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.$emit('RhythmOK', para.GpNo);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 按钮点击保存执行
    */
    save() {
      this.doSave();
    },
    /* 全选
    */
    checkAll(e) {
      if (e) {
        this.select = true;
      } else {
        this.select = false;
      }
      this.selectCheckBox(e);
    },
    /* 执行全选操作
    */
    selectCheckBox(_flag) {
      var _arr = [];
      this.card_list.forEach(item => {
        if (!item.isdisabled) {
          item.ischecked = _flag; //全选
        }
        _arr.push(item);
      });
      this.cardlist = _arr;
      this.getCheckedDataDevice();
      _arr = null;
    },
    changeEchartsData(data) {
      this.lightTimeList = data.timneList
      this.hclConfig.HCLDimmingMode = data.configList.HCLDimmingMode
      this.hclConfig.HCLMode = data.configList.HCLMode
    },
    // 获取日期的时间戳
    gettimeStamp(time) {
      return new Date(time.replace(/-/g, '/')).getTime();
    },
    // 获取时间戳转化为时间
    getDateFormat(timestamp) {
      return new Date(timestamp);
    }
  }
};
</script>

<style lang="scss" scoped>
.rhythm-chart {
  min-width: 1200px;
  height: 400px;
  margin: 0 auto;
  position: relative;
  padding: 0 140px;
  box-sizing: border-box;
  &-tips {
    position: absolute;
    right: 40px;
    color: #b3b8c3;
    font-size: 14px;
    top: 17px;
  }
}
.rhythm_step {
  margin-bottom: 20px;
}

.tab-content {
  margin-top: 0px;
}
.chart-top {
  display: flex;
  justify-content: space-between;
  padding-left: 5%;
  padding-right: 8%;
}
.template-btn-box {
  max-width: 290px;
  margin-left: 20px;
}
.template-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.template-btn-choose {
  width: 128px;
  height: 38px;
  line-height: 13px;
  padding: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  background: #4f8ee7;
  text-align: center;
}
.template-btn-choose:nth-child(2) {
  margin-left: 10px;
}
.template-btn-save {
  margin-top: 12px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2a72ea;
  border: 1px solid #2a72ea;
  background: #fff;
  text-align: center;
  cursor: pointer;
}
.template-top {
  display: flex;
  width: 850px;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 0 10px;
  .color {
    color: #2c75ec !important;
  }
  .delete:hover {
    border-color: #2c75ec !important;
    color: #2c75ec !important;
  }
  .delete {
    margin-left: 20px;
    border-color: #2c75ec !important;
  }
}
.template-mini {
  opacity: 0.6;
  color: #2a72ea;
  font-family: PingFang SC;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
}
.template-mini:hover {
  opacity: 0.8;
}
.template-mini-icon {
  width: 81px;
  height: 32px;
  background: #e5effe;
  border: 2px solid #e5effe;
  border-radius: 4px;
  background-position: 0px 1px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.mini-act {
  opacity: 1;
  font-weight: bold;
  .template-mini-icon {
    border: 2px solid #2a72ea;
  }
}
.ehy_cont {
  min-height: 650px;
  height: 100%;
  overflow: auto;
}
.template-box {
  min-width: 1080px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  box-shadow: 0 1px 3px rgb(0 0 0 / 30%);

  .el-icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
.template-content {
  .search_way {
    margin-bottom: 20px;
  }
  .card-box {
    display: flex;
    justify-content: center;
    padding: 30px 0 40px 0;
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    width: 840px;
    height: 450px;
    margin: 0 auto;
  }
  .card-item {
    position: relative;
    width: 260px;
    height: 210px;
    box-sizing: border-box;
    margin: 10px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid #dde2ea;
    overflow: hidden;
    .card-top {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 107px;
      color: #fff;
      background: linear-gradient(90deg, #6d9ee3, #2a72ea);
      margin-bottom: 10px;
      .card-checkbox {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .top-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .card-title {
        width: 100%;
        box-sizing: border-box;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
        padding: 0 20px;
        word-wrap: break-word;
        ::v-deep .card-input {
          flex: 1;
          input {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 18px;
            // border: none;
            color: #fff !important;
          }
        }
      }
    }
    .card-content {
      background: #fff;
      padding: 0 20px;
      .card-ul {
        color: #a8a8a8;
        margin-bottom: 5px;
      }
      .card-li {
        display: flex;
      }
      .font-color {
        flex: 1;
        color: #1f1f1f;
      }
    }
    .card-bottom {
      display: flex;
      margin-top: 10px;
      .card-choose {
        width: 100%;
        border: 1px solid #2a72ea;
        color: #2a72ea;
        background: #fff;
        text-align: center;
        padding: 5px 0;
      }
    }
  }
}

.curr-tip-inlinesub {
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.second-tab-cont-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.curr-tip-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.icon-delete {
  margin-right: 20px;
  margin-left: auto;
}
.user-defined {
  width: 900px;
  margin: 20px auto;
}
.user-defined-contianer {
  height: 340px;
  overflow: auto;
}
.rodio-type {
  display: inline-block;
  width: 19px;
  height: 11px;
}
.curve {
  background: url("~@/assets/img/rhythm/curve@2x.png") no-repeat;
  background-size: 100% 100%;
}
.jump {
  background: url("~@/assets/img/rhythm/jump@2x.png") no-repeat;
  background-size: 100% 100%;
}

.curve-act {
  background: url("~@/assets/img/rhythm/curve-act@2x.png") no-repeat;
  background-size: 100% 100%;
}

.jump-act {
  background: url("~@/assets/img/rhythm/jump-act@2x.png") no-repeat;
  background-size: 100% 100%;
}
.template-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba($color: #000000, $alpha: 0.4);
  z-index: 999;
}

::v-deep .el-radio {
  display: flex;
}
::v-deep .el-radio__input {
  border: 1px solid #333;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  display: flex;
}
::v-deep .el-radio__inner {
  border: 3px solid #fff !important;
  width: 12px;
  height: 12px;
  margin: 0;
}
.use-defined-item {
  position: relative;
  display: flex;
  align-items: center;
  margin: 12px 0;
}

::v-deep .cct-color .el-slider__runway {
  background: linear-gradient(90deg, #ff7e00 0%, #ffe36d 9%, #fffaf1 33%, #faf9f8 38%, #f5f9ff 44%, #bbd6ff 100%);
}
.add-tips {
  margin-top: 20px;
  font-size: 12px;
  .el-icon-star-on {
    font-size: 5px;
    color: #2a72ea;
    margin-right: 10px;
    transform: scale(0.7);
  }
}
.item-border {
  margin: 12px 0 0 0;
  padding-top: 20px;
  border-top: 2px dotted #dfdfdf;
  .add-btn:hover {
    background: #4f8ee7 !important;
  }
  .add-btn {
    color: #fff !important;
    background-color: #4f8ee7 !important;
  }
  .curr-tip-item span {
    color: #2a72ea !important;
  }
  ::v-deep input {
    border: 1px dashed #2a72ea !important;
    background: rgba($color: #2a72ea, $alpha: 0.1) !important;
    color: #2a72ea !important;
  }
  ::v-deep .el-icon-time {
    color: #2a72ea !important;
  }
}

.el-icon-plus {
  font-weight: 700;
  margin-right: 20px;
}
.use-defined-add {
  position: absolute;
  width: 120px;
  text-align: right;
  left: -130px;
  color: #2a72ea;
}

.rhythm .slider_width .input_slider {
  min-width: 230px;
}

.template-custom {
  padding: 30px 40px;
}
.template-item {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/hcl/template-bg@2x.png") no-repeat 50px 87px /
    80% 90%;
  overflow: hidden;
}
.template-img-big {
  position: absolute;
  right: 80px;
  bottom: 0px;
  width: 596px;
  height: 261px;
  background-size: 100% 100%;
}
.template-footer {
  text-align: center;
  background-color: #e5effe;
  padding: 18px 0;
}
.template-text {
  width: 850px;
  margin: 0 auto;
  box-sizing: border-box;
  color: #2a72ea;
  .template-des {
    position: relative;
    z-index: 1;
    width: 850px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2a72ea;
    line-height: 21px;
    padding-top: 40px;
  }
}

.template-btn {
  width: 80px;
  background: #2a72ea;
  color: #fff;
  padding: 12px 18px;
  border-radius: 3px;
  margin: 0 auto;
  cursor: pointer;
}

.blue_border {
  margin-left: 40px;
}
.button_box {
  height: 130px;
}
.tab-top {
  display: flex;
  padding: 0 140px;
  box-sizing: border-box;
  min-width: 1200px;
}

.wrapperMyself {
  .save_blue {
    margin-left: 60px;
    background: #2a72ea !important;
    border: solid 1px #2a72ea !important;
  }
  .save_blue:hover,
  .save_blue:focus,
  .save_blue:active {
    background: #2a72ea !important;
    border: solid 1px #2a72ea !important;
  }
}

.el-dropdown-link {
  display: flex;
  align-items: center;
}

::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  max-width: 150px;
  input {
    text-align: center;
  }
}

// @media only screen and (min-width: 1441px) and (max-width: 1600px) {
//   .ehy_cont {
//     min-height: 500px;
//   }
// }

@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  .ehy_cont {
    margin-top: 0 !important;
    min-height: 620px !important;
  }

  .button_box {
    height: 60px !important;
  }

  .tab-top {
    padding: 0 50px !important;
  }
  .rhythm-chart {
    padding: 0 50px !important;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1366px) {
  .ehy_cont {
    margin-top: 0 !important;
    min-height: 620px !important;
  }
  .second_tab_cont {
    height: 315px;
  }
  .tab-top {
    padding: 0 50px !important;
  }
  .rhythm-chart {
    padding: 0 50px !important;
  }
  .button_box {
    height: 60px !important;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1280px) {
  .ehy_cont {
    margin-top: 0 !important;
    min-height: 620px !important;
  }
  .button_box {
    height: 60px !important;
  }
  .tab-top {
    padding: 0 10px !important;
  }
  .rhythm-chart {
    padding: 0 10px !important;
  }
}

@media screen and (min-width: 1441px) and (max-width: 1600px) {
  .ehy_cont {
    margin-top: 0 !important;
    min-height: 620px !important;
  }
  .button_box {
    height: 60px !important;
  }
}

.search_way ::v-deep .el-input__inner {
  border-bottom: 1px solid #d9dde3 !important;
}

::v-deep .custom_color_picker {
  margin-left: 56px;
  display: flex;
  align-items: center;
  .el-icon-close:hover {
    animation: normal !important;
  }
}

::v-deep .el-icon-arrow-left {
  display: none;
}
::v-deep .el-carousel__arrow {
  width: 31px !important;
  height: 54px !important;
}
::v-deep .el-carousel__arrow--right {
  background-size: 100% 100% !important;
  background: url("~@/assets/img/hcl/arrow-right@2x.png") no-repeat;
}
::v-deep .el-carousel__arrow--left {
  background-size: 100% 100% !important;
  background: url("~@/assets/img/hcl/arrow-left@2x.png") no-repeat;
}
</style>
<style lang="scss">
.template-des .template-name {
  font-size: 23px;
  font-family: PingFang SC;
  font-weight: 300;
  color: #2a72ea;
  margin-top: 46px;
}
.template-des h3 {
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: 800;
  line-height: 60px;
}
.template-des .template-tips {
  width: 324px;
  font-size: 12px;
  line-height: 24px;
}
.template-des .template-ideas {
  line-height: 32px;
  margin: 50px 0;
}
</style>
